import React from "react";
import styled from "styled-components";

function AcceptableUsePolicyPage(): React.JSX.Element {
  const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 0;
    margin: 0;
    overflow: hidden;
  `;

  return (
    <Container data-testid="terms-of-service">
      <iframe
        src="https://app.termly.io/policy-viewer/policy.html?policyUUID=a53fb5ce-7970-4679-8a07-c3001d67bd2c"
        title="Acceptable Use Policy"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
      />
    </Container>
  );
}

export default AcceptableUsePolicyPage;
